exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ColumnHeader {\n    position: relative;\n}\n\n.ColumnHeader-label {\n    display: inline-block;\n    position: absolute;\n    top: 7px;\n    left: 0;\n    right: 15px;\n    user-select: none;\n    overflow: hidden;\n}\n\n.ColumnHeader svg {\n    position: absolute;\n    top: 5px;\n    right: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/datatable/ColumnHeader.css
// module id = 1091
// module chunks = 0